export default __webpack_public_path__ + "static/media/secondary.b25f5b05663404bca63155c3355c6690.svg";